import { Grid, FormControl, InputLabel, MenuItem, Select } from '@mui/material';

type Props = {
    grid?: boolean;
    caption: string;
    defVal?: number;
    min?: number;
    max?: number;
    interval: number;
    onChange: (value: number) => void;
    [key: string]: unknown;
};

/**
 * Componente para seleccionar intervalos de numeros. Empezando por min, hasta max, cada interval. El valor 0 estará representado por ∞.
 * string caption - field caption
 * int defVal - selected value
 * int min - minimum value available for selection
 * int max - maximum value available for selection
 * int interval - length of intervals
 * Function onChange(number) - callback for select
 */
export function SttSelectNumbersInterval({
    grid = false,
    caption,
    defVal = 0,
    min = 10,
    max = 23 * 60, // From 00:00 to 23:00
    interval,
    onChange,
    ...rest
}: Props): React.ReactElement {
    const menuItems = [];

    // Creamos los elementos
    for (let i = min; i <= max; i += interval) {
        menuItems.push(
            <MenuItem key={i} value={i}>
                {i === 0 ? '∞' : i}
            </MenuItem>,
        );
    }

    const content = (
        <FormControl variant="outlined" size="small" style={{ width: '100%' }}>
            <InputLabel>{caption}</InputLabel>
            <Select
                value={defVal}
                onChange={(e: any) => onChange(e.target.value as number)}
                label={caption}
            >
                {menuItems}
            </Select>
        </FormControl>
    );

    return grid ? <Grid {...rest}>{content}</Grid> : content;
}
